export default __webpack_public_path__ + "static/DisplayHDR-400-54b2b18a9d0b5446dd47ec148e3e1671.png";